import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { ISOCItemResponse } from "../../services/pet-detail/pet-detail.interface";
import { PetFormType } from "../../services/pet-create/pet-create.schema";
import { actionTypes } from "./pet.actions";

export interface IPetState {
  newPetImage: File | null;
  newPetForm: PetFormType | null;
  petInfo: IPetItemResponse | null;
  petInfoMap: Record<string, IPetItemResponse>;
  SOCSelected: ISOCItemResponse | null;
  petList: IPetItemResponse[] | null;
}

const initialState: IPetState = {
  newPetImage: null,
  newPetForm: null,
  petInfo: null,
  petInfoMap: {},
  SOCSelected: null,
  petList: null,
};

export const petReducer = (
  state: IPetState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_NEW_PET_IMAGE:
    return {
      ...state,
      newPetImage: action.payload,
    };
  case actionTypes.SET_NEW_PET_FORM:
    return {
      ...state,
      newPetForm: action.payload,
    };
  // case actionTypes.SET_NEW_PET_TWO_FORM:
  //   return {
  //     ...state,
  //     newPetTwoForm: action.payload,
  //   };
  case actionTypes.SET_PET_INFO:
    return {
      ...state,
      petInfo: action.payload,
      petInfoMap: action.payload ?
        { ...state.petInfoMap, [action.payload.id]: action.payload } :
        state.petInfoMap,
    };
  case actionTypes.CLEAR_PET_INFO_MAP:
    return {
      ...state,
      petInfoMap: {},
      petInfo: null,
    };
  case actionTypes.SET_SOC_SELECTED:
    return {
      ...state,
      SOCSelected: action.payload,
    };
  case actionTypes.SET_PET_LIST: {
    return {
      ...state,
      petList: action.payload,
    };
  }
  default:
    return state;
  }
};
